import { render, staticRenderFns } from "./CompetencesScolaires.vue?vue&type=template&id=c90a75e2&"
import script from "./CompetencesScolaires.vue?vue&type=script&lang=js&"
export * from "./CompetencesScolaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports